import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-team-cooperation",
  "use": "icon-team-cooperation-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol viewBox=\"0 0 12 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-team-cooperation\">\n  <path d=\"M5.0484 0L6.2484 1.33333H11.4C11.7312 1.33333 12 1.632 12 2V11.3333C12 11.7013 11.7312 12 11.4 12H0.6C0.2688 12 0 11.7013 0 11.3333V0.666667C0 0.298667 0.2688 0 0.6 0H5.0484ZM6 4.33333H4.8V8.33333H7.8V7H6V4.33333Z\" fill=\"#D79E31\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol